module.exports = __webpack_public_path__ + "img/20190611_113036_010.c62f3a86.jpg";